import React from "react";
import pic from "../../../icons/deta.jpg";


class ConfidentalLeft extends React.Component {
    render() {
        return (
            <div className='word-wrap'>
                <h2>Site details</h2>
                <img className="left-pane-pic" style={{marginTop:'50px', width:'180px', height:'180px'}} src={pic} alt="Logo" />
                <div style={{marginTop:'30px'}}>Please provide following details</div>
            </div>
        );
    }
}
export default ConfidentalLeft







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/MetadataLeft.js